import type { Business } from "@/types/directory";

/**
 * Extra demo listings (part 1) seeded to make each district and taluk feel full.
 * Covers South Canara and Udupi towns.
 */
export const businessesPartE: Business[] = [
  {
    id: "biz-29",
    slug: "kadamba-multi-speciality-pharmacy",
    name: "Kadamba Multi-Speciality Pharmacy",
    tagline: "24-hour pharmacy with home delivery across Mangaluru",
    description:
      "A round-the-clock pharmacy in Mangaluru stocking prescription medicines, wellness products and medical equipment, with free home delivery and insurance claim support.",
    categorySlug: "healthcare",
    subcategory: "Pharmacy",
    districtSlug: "south-canara",
    locationSlug: "mangaluru",
    address: "Kankanady Road, Mangaluru, Dakshina Kannada - 575002",
    phone: "+91 824 243 5566",
    whatsapp: "+91 98860 35566",
    email: "care@kadambapharmacy.in",
    website: "https://kadambapharmacy.in",
    mapEmbedUrl: "https://www.google.com/maps?q=Kankanady%20Mangaluru%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20modern%20pharmacy%20counter%20with%20neatly%20organised%20medicine%20shelves%20and%20a%20friendly%20clean%20interior%2C%20professional%20healthcare%20retail%20photography&width=1200&height=800&seq=cbc-biz-kadamba-pharmacy-cover-01&orientation=landscape",
    gallery: [],
    rating: 4.4,
    reviewCount: 187,
    verified: true,
    sponsored: false,
    featured: true,
    plan: "Business",
    openNow: true,
    yearsInBusiness: 11,
    hours: [
      { day: "Monday", open: "00:00", close: "23:59", closed: false },
      { day: "Tuesday", open: "00:00", close: "23:59", closed: false },
      { day: "Wednesday", open: "00:00", close: "23:59", closed: false },
      { day: "Thursday", open: "00:00", close: "23:59", closed: false },
      { day: "Friday", open: "00:00", close: "23:59", closed: false },
      { day: "Saturday", open: "00:00", close: "23:59", closed: false },
      { day: "Sunday", open: "00:00", close: "23:59", closed: false },
    ],
    services: ["Prescription Medicines", "Home Delivery", "Health Devices", "Insurance Claims"],
    tags: ["24x7", "Home Delivery", "Licensed", "Chemist"],
    reviews: [],
  },
  {
    id: "biz-30",
    slug: "netravathi-diagnostics-and-scan-centre",
    name: "Netravathi Diagnostics & Scan Centre",
    tagline: "Accurate lab reports, delivered on time",
    description:
      "A NABL-accredited diagnostic centre in Mangaluru offering blood tests, ECG, ultrasound, CT and MRI scans with online report delivery and home sample collection.",
    categorySlug: "healthcare",
    subcategory: "Diagnostic Labs",
    districtSlug: "south-canara",
    locationSlug: "mangaluru",
    address: "Balmatta Road, Mangaluru, Dakshina Kannada - 575001",
    phone: "+91 824 244 6677",
    whatsapp: "+91 94490 26677",
    email: "reports@netravathilabs.in",
    website: "https://netravathilabs.in",
    mapEmbedUrl: "https://www.google.com/maps?q=Balmatta%20Mangaluru%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20diagnostic%20laboratory%20with%20advanced%20scanning%20equipment%20and%20clean%20bright%20interior%2C%20professional%20healthcare%20technology%20photography&width=1200&height=800&seq=cbc-biz-netravathi-labs-cover-01&orientation=landscape",
    gallery: [],
    rating: 4.5,
    reviewCount: 231,
    verified: true,
    sponsored: false,
    featured: false,
    plan: "Business",
    openNow: true,
    yearsInBusiness: 14,
    hours: [
      { day: "Monday", open: "07:00", close: "21:00", closed: false },
      { day: "Tuesday", open: "07:00", close: "21:00", closed: false },
      { day: "Wednesday", open: "07:00", close: "21:00", closed: false },
      { day: "Thursday", open: "07:00", close: "21:00", closed: false },
      { day: "Friday", open: "07:00", close: "21:00", closed: false },
      { day: "Saturday", open: "07:00", close: "20:00", closed: false },
      { day: "Sunday", open: "08:00", close: "13:00", closed: false },
    ],
    services: ["Blood Tests", "Ultrasound", "CT & MRI Scan", "Home Sample Collection"],
    tags: ["NABL Accredited", "Online Reports", "Home Collection", "Diagnostics"],
    reviews: [],
  },
  {
    id: "biz-31",
    slug: "mangaluru-gold-palace",
    name: "Mangaluru Gold Palace",
    tagline: "Hallmarked gold and diamond jewellery for every occasion",
    description:
      "A family jewellery showroom in Mangaluru offering BIS-hallmarked gold, diamond and silver collections with transparent making charges and exchange offers.",
    categorySlug: "retail",
    subcategory: "Jewellery Showrooms",
    districtSlug: "south-canara",
    locationSlug: "mangaluru",
    address: "G.H.S. Road, Mangaluru, Dakshina Kannada - 575001",
    phone: "+91 824 244 8899",
    whatsapp: "+91 98865 48899",
    email: "sales@mangalurugoldpalace.in",
    website: "https://mangalurugoldpalace.in",
    mapEmbedUrl: "https://www.google.com/maps?q=GHS%20Road%20Mangaluru%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20golden%20jewellery%20showroom%20interior%20with%20lit%20glass%20display%20counters%20of%20gold%20ornaments%2C%20elegant%20luxury%20retail%20photography&width=1200&height=800&seq=cbc-biz-mangaluru-goldpalace-cover-01&orientation=landscape",
    gallery: [],
    rating: 4.6,
    reviewCount: 268,
    verified: true,
    sponsored: true,
    featured: false,
    plan: "Business",
    openNow: true,
    yearsInBusiness: 24,
    hours: [
      { day: "Monday", open: "10:00", close: "20:30", closed: false },
      { day: "Tuesday", open: "10:00", close: "20:30", closed: false },
      { day: "Wednesday", open: "10:00", close: "20:30", closed: false },
      { day: "Thursday", open: "10:00", close: "20:30", closed: false },
      { day: "Friday", open: "10:00", close: "21:00", closed: false },
      { day: "Saturday", open: "10:00", close: "21:00", closed: false },
      { day: "Sunday", open: "10:30", close: "19:30", closed: false },
    ],
    services: ["Gold Jewellery", "Diamond Jewellery", "Silver Articles", "Exchange Offers"],
    tags: ["BIS Hallmarked", "Transparent Rates", "Exchange", "Bridal Sets"],
    reviews: [],
  },
  {
    id: "biz-32",
    slug: "sharada-tailors-and-boutique",
    name: "Sharada Tailors & Boutique",
    tagline: "Perfect fits and designer blouses, stitched with care",
    description:
      "A well-known tailoring house in Mangaluru offering custom stitching, designer blouses, bridal wear alterations and uniform stitching with neat finishing and on-time delivery.",
    categorySlug: "retail",
    subcategory: "Fashion & Apparel",
    districtSlug: "south-canara",
    locationSlug: "mangaluru",
    address: "Car Street, Mangaluru, Dakshina Kannada - 575001",
    phone: "+91 824 244 3311",
    whatsapp: "+91 97403 43311",
    email: "hello@sharadaboutique.in",
    website: "",
    mapEmbedUrl: "https://www.google.com/maps?q=Car%20Street%20Mangaluru%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Neat%20tailoring%20boutique%20with%20colourful%20fabrics%2C%20measuring%20tape%20and%20sewing%20machine%20on%20a%20clean%20work%20table%2C%20warm%20daylight%2C%20apparel%20craft%20photography&width=1200&height=800&seq=cbc-biz-sharada-boutique-cover-01&orientation=landscape",
    gallery: [],
    rating: 4.3,
    reviewCount: 96,
    verified: false,
    sponsored: false,
    featured: false,
    plan: "Free",
    openNow: true,
    yearsInBusiness: 17,
    hours: [
      { day: "Monday", open: "09:30", close: "20:00", closed: false },
      { day: "Tuesday", open: "09:30", close: "20:00", closed: false },
      { day: "Wednesday", open: "09:30", close: "20:00", closed: false },
      { day: "Thursday", open: "09:30", close: "20:00", closed: false },
      { day: "Friday", open: "09:30", close: "20:00", closed: false },
      { day: "Saturday", open: "09:30", close: "20:30", closed: false },
      { day: "Sunday", open: "00:00", close: "00:00", closed: true },
    ],
    services: ["Custom Stitching", "Designer Blouses", "Alterations", "Uniform Stitching"],
    tags: ["On-Time Delivery", "Designer Blouses", "Bridal Wear", "Boutique"],
    reviews: [],
  },
  {
    id: "biz-33",
    slug: "puttur-sagar-bakes",
    name: "Puttur Sagar Bakes",
    tagline: "Fresh bakes, cakes and evening snacks every day",
    description:
      "A popular bakery in Puttur baking fresh bread, puffs, cookies and customised celebration cakes daily, with a cosy sit-down corner for tea and snacks.",
    categorySlug: "restaurants",
    subcategory: "Cafes & Bakeries",
    districtSlug: "south-canara",
    locationSlug: "puttur",
    address: "Mangalore Road, Puttur, Dakshina Kannada - 574201",
    phone: "+91 8251 234 220",
    whatsapp: "+91 96866 34220",
    email: "orders@puttursagarbakes.in",
    website: "",
    mapEmbedUrl: "https://www.google.com/maps?q=Puttur%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cosy%20bakery%20display%20with%20fresh%20breads%2C%20cakes%20and%20pastries%20under%20bright%20counter%20lighting%2C%20inviting%20food%20retail%20photography&width=1200&height=800&seq=cbc-biz-puttur-bakes-cover-01&orientation=landscape",
    gallery: [],
    rating: 4.4,
    reviewCount: 118,
    verified: true,
    sponsored: false,
    featured: false,
    plan: "Free",
    openNow: true,
    yearsInBusiness: 9,
    hours: [
      { day: "Monday", open: "07:00", close: "21:30", closed: false },
      { day: "Tuesday", open: "07:00", close: "21:30", closed: false },
      { day: "Wednesday", open: "07:00", close: "21:30", closed: false },
      { day: "Thursday", open: "07:00", close: "21:30", closed: false },
      { day: "Friday", open: "07:00", close: "22:00", closed: false },
      { day: "Saturday", open: "07:00", close: "22:00", closed: false },
      { day: "Sunday", open: "07:30", close: "21:00", closed: false },
    ],
    services: ["Fresh Breads", "Custom Cakes", "Puffs & Snacks", "Takeaway"],
    tags: ["Fresh Daily", "Custom Cakes", "Takeaway", "Bakery"],
    reviews: [],
  },
  {
    id: "biz-34",
    slug: "sri-dharmasthala-homestay",
    name: "Sri Dharmasthala Homestay",
    tagline: "Peaceful temple-town stay near Puttur",
    description:
      "A clean family homestay near Puttur offering comfortable rooms, home-cooked meals and easy access to Dharmasthala temple, ideal for pilgrims and weekend travellers.",
    categorySlug: "hotels",
    subcategory: "Homestays",
    districtSlug: "south-canara",
    locationSlug: "puttur",
    address: "Dharmasthala Road, Puttur, Dakshina Kannada - 574216",
    phone: "+91 8251 236 780",
    whatsapp: "+91 97407 36780",
    email: "stay@sridharmasthalahomestay.in",
    website: "https://sridharmasthalahomestay.in",
    mapEmbedUrl: "https://www.google.com/maps?q=Puttur%20Dharmasthala%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Peaceful%20South%20Indian%20homestay%20with%20tiled%20roof%20veranda%2C%20greenery%20and%20warm%20evening%20lighting%2C%20welcoming%20hospitality%20photography&width=1200&height=800&seq=cbc-biz-dharmasthala-homestay-cover-01&orientation=landscape",
    gallery: [],
    rating: 4.7,
    reviewCount: 142,
    verified: true,
    sponsored: false,
    featured: false,
    plan: "Business",
    openNow: true,
    yearsInBusiness: 6,
    hours: [
      { day: "Monday", open: "00:00", close: "23:59", closed: false },
      { day: "Tuesday", open: "00:00", close: "23:59", closed: false },
      { day: "Wednesday", open: "00:00", close: "23:59", closed: false },
      { day: "Thursday", open: "00:00", close: "23:59", closed: false },
      { day: "Friday", open: "00:00", close: "23:59", closed: false },
      { day: "Saturday", open: "00:00", close: "23:59", closed: false },
      { day: "Sunday", open: "00:00", close: "23:59", closed: false },
    ],
    services: ["Family Rooms", "Home-Cooked Meals", "Parking", "Temple Trips"],
    tags: ["Homely Stay", "Home Food", "Pilgrim Friendly", "Family Rooms"],
    reviews: [],
  },
  {
    id: "biz-35",
    slug: "puttur-care-polyclinic",
    name: "Puttur Care Polyclinic",
    tagline: "Everyday care for Puttur families",
    description:
      "A neighbourhood polyclinic in Puttur offering general medicine, paediatrics, minor procedures and health checkups with experienced doctors and quick appointments.",
    categorySlug: "healthcare",
    subcategory: "Multispeciality Clinics",
    districtSlug: "south-canara",
    locationSlug: "puttur",
    address: "Main Road, Puttur, Dakshina Kannada - 574201",
    phone: "+91 8251 235 440",
    whatsapp: "+91 90718 35440",
    email: "care@putturpolyclinic.in",
    website: "",
    mapEmbedUrl: "https://www.google.com/maps?q=Puttur%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Clean%20modern%20clinic%20consultation%20room%20with%20comfortable%20seating%20and%20bright%20natural%20light%2C%20professional%20healthcare%20interior%20photography&width=1200&height=800&seq=cbc-biz-puttur-polyclinic-cover-01&orientation=landscape",
    gallery: [],
    rating: 4.3,
    reviewCount: 87,
    verified: false,
    sponsored: false,
    featured: false,
    plan: "Free",
    openNow: true,
    yearsInBusiness: 8,
    hours: [
      { day: "Monday", open: "09:00", close: "20:00", closed: false },
      { day: "Tuesday", open: "09:00", close: "20:00", closed: false },
      { day: "Wednesday", open: "09:00", close: "20:00", closed: false },
      { day: "Thursday", open: "09:00", close: "20:00", closed: false },
      { day: "Friday", open: "09:00", close: "20:00", closed: false },
      { day: "Saturday", open: "09:00", close: "18:00", closed: false },
      { day: "Sunday", open: "09:00", close: "13:00", closed: false },
    ],
    services: ["General Medicine", "Paediatrics", "Health Checkups", "Minor Procedures"],
    tags: ["Quick Appointments", "Family Clinic", "Experienced Doctors", "Walk-In"],
    reviews: [],
  },
  {
    id: "biz-36",
    slug: "surathkal-beach-cafe",
    name: "Surathkal Beach Cafe",
    tagline: "Coffee, snacks and sea breeze by the shore",
    description:
      "A relaxed beachside cafe in Surathkal serving fresh coffee, wood-fired pizzas, sandwiches and coastal snacks with an open-air deck overlooking the sea.",
    categorySlug: "restaurants",
    subcategory: "Cafes & Bakeries",
    districtSlug: "south-canara",
    locationSlug: "surathkal",
    address: "Beach Road, Surathkal, Dakshina Kannada - 575014",
    phone: "+91 824 247 9922",
    whatsapp: "+91 96863 79922",
    email: "hello@surathkalbeachcafe.in",
    website: "https://surathkalbeachcafe.in",
    mapEmbedUrl: "https://www.google.com/maps?q=Surathkal%20Beach%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Cosy%20beachside%20cafe%20with%20wooden%20deck%20seating%2C%20string%20lights%20and%20sea%20view%2C%20warm%20evening%20ambience%2C%20inviting%20hospitality%20photography&width=1200&height=800&seq=cbc-biz-surathkal-beachcafe-cover-01&orientation=landscape",
    gallery: [],
    rating: 4.5,
    reviewCount: 176,
    verified: true,
    sponsored: true,
    featured: false,
    plan: "Business",
    openNow: true,
    yearsInBusiness: 5,
    hours: [
      { day: "Monday", open: "08:00", close: "23:00", closed: false },
      { day: "Tuesday", open: "08:00", close: "23:00", closed: false },
      { day: "Wednesday", open: "08:00", close: "23:00", closed: false },
      { day: "Thursday", open: "08:00", close: "23:00", closed: false },
      { day: "Friday", open: "08:00", close: "23:30", closed: false },
      { day: "Saturday", open: "08:00", close: "23:30", closed: false },
      { day: "Sunday", open: "08:00", close: "23:00", closed: false },
    ],
    services: ["Coffee & Brews", "Wood-Fired Pizza", "Sandwiches", "Sea-Facing Deck"],
    tags: ["Sea View", "Open Air", "Live Music", "Wi-Fi"],
    reviews: [],
  },
  {
    id: "biz-37",
    slug: "nit-road-books-and-stationery",
    name: "NIT Road Books & Stationery",
    tagline: "Textbooks, stationery and print services near NIT",
    description:
      "A student-friendly bookstore near NIT Surathkal stocking academic textbooks, notebooks, art supplies and offering printing, binding and lamination services.",
    categorySlug: "retail",
    subcategory: "Gifts & Stationery",
    districtSlug: "south-canara",
    locationSlug: "surathkal",
    address: "NIT Road, Surathkal, Dakshina Kannada - 575025",
    phone: "+91 824 247 3355",
    whatsapp: "+91 97315 73355",
    email: "shop@nitbooks.in",
    website: "",
    mapEmbedUrl: "https://www.google.com/maps?q=NIT%20Surathkal%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Neat%20bookstore%20interior%20with%20well%20stocked%20shelves%20of%20books%20and%20stationery%20displays%20under%20bright%20lighting%2C%20academic%20retail%20photography&width=1200&height=800&seq=cbc-biz-nit-books-cover-01&orientation=landscape",
    gallery: [],
    rating: 4.2,
    reviewCount: 74,
    verified: false,
    sponsored: false,
    featured: false,
    plan: "Free",
    openNow: true,
    yearsInBusiness: 10,
    hours: [
      { day: "Monday", open: "09:00", close: "20:30", closed: false },
      { day: "Tuesday", open: "09:00", close: "20:30", closed: false },
      { day: "Wednesday", open: "09:00", close: "20:30", closed: false },
      { day: "Thursday", open: "09:00", close: "20:30", closed: false },
      { day: "Friday", open: "09:00", close: "20:30", closed: false },
      { day: "Saturday", open: "09:00", close: "20:30", closed: false },
      { day: "Sunday", open: "10:00", close: "14:00", closed: false },
    ],
    services: ["Academic Books", "Stationery", "Printing & Binding", "Lamination"],
    tags: ["Student Friendly", "Print Services", "Books", "Stationery"],
    reviews: [],
  },
  {
    id: "biz-38",
    slug: "surathkal-mobile-world",
    name: "Surathkal Mobile World",
    tagline: "Latest smartphones with easy EMI options",
    description:
      "An authorised mobile store in Surathkal selling the latest smartphones, accessories and offering repairs, screen replacement and instant EMI options.",
    categorySlug: "electronics-mobiles",
    subcategory: "Mobile Stores",
    districtSlug: "south-canara",
    locationSlug: "surathkal",
    address: "Main Road, Surathkal, Dakshina Kannada - 575014",
    phone: "+91 824 247 5566",
    whatsapp: "+91 90085 75566",
    email: "sales@surathkalmobile.in",
    website: "",
    mapEmbedUrl: "https://www.google.com/maps?q=Surathkal%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20mobile%20phone%20store%20with%20smartphones%20displayed%20on%20lit%20shelves%20and%20clean%20glass%20counters%2C%20bright%20technology%20retail%20photography&width=1200&height=800&seq=cbc-biz-surathkal-mobile-cover-01&orientation=landscape",
    gallery: [],
    rating: 4.3,
    reviewCount: 132,
    verified: true,
    sponsored: false,
    featured: false,
    plan: "Free",
    openNow: true,
    yearsInBusiness: 7,
    hours: [
      { day: "Monday", open: "10:00", close: "20:30", closed: false },
      { day: "Tuesday", open: "10:00", close: "20:30", closed: false },
      { day: "Wednesday", open: "10:00", close: "20:30", closed: false },
      { day: "Thursday", open: "10:00", close: "20:30", closed: false },
      { day: "Friday", open: "10:00", close: "21:00", closed: false },
      { day: "Saturday", open: "10:00", close: "21:00", closed: false },
      { day: "Sunday", open: "10:30", close: "19:00", closed: false },
    ],
    services: ["Smartphones", "Accessories", "Mobile Repairs", "EMI Options"],
    tags: ["Easy EMI", "Authorised Store", "Repairs", "Accessories"],
    reviews: [],
  },
  {
    id: "biz-39",
    slug: "moodabidri-care-hospital",
    name: "Moodabidri Care Hospital",
    tagline: "Reliable healthcare for Moodabidri and nearby taluks",
    description:
      "A 60-bed hospital in Moodabidri offering general surgery, orthopaedics, maternity and 24-hour emergency care with modern diagnostics and caring staff.",
    categorySlug: "healthcare",
    subcategory: "Multispeciality Hospitals",
    districtSlug: "south-canara",
    locationSlug: "moodabidri",
    address: "Hospital Road, Moodabidri, Dakshina Kannada - 574227",
    phone: "+91 8258 236 900",
    whatsapp: "+91 96866 36900",
    email: "care@moodabidricare.in",
    website: "https://moodabidricare.in",
    mapEmbedUrl: "https://www.google.com/maps?q=Moodabidri%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20hospital%20building%20exterior%20with%20clean%20facade%20and%20landscaped%20entrance%20in%20bright%20daylight%2C%20professional%20healthcare%20architecture%20photography&width=1200&height=800&seq=cbc-biz-moodabidri-hospital-cover-01&orientation=landscape",
    gallery: [],
    rating: 4.5,
    reviewCount: 203,
    verified: true,
    sponsored: false,
    featured: false,
    plan: "Business",
    openNow: true,
    yearsInBusiness: 16,
    hours: [
      { day: "Monday", open: "00:00", close: "23:59", closed: false },
      { day: "Tuesday", open: "00:00", close: "23:59", closed: false },
      { day: "Wednesday", open: "00:00", close: "23:59", closed: false },
      { day: "Thursday", open: "00:00", close: "23:59", closed: false },
      { day: "Friday", open: "00:00", close: "23:59", closed: false },
      { day: "Saturday", open: "00:00", close: "23:59", closed: false },
      { day: "Sunday", open: "00:00", close: "23:59", closed: false },
    ],
    services: ["24x7 Emergency", "General Surgery", "Orthopaedics", "Maternity"],
    tags: ["Emergency Care", "Modern Diagnostics", "Insurance", "Pharmacy"],
    reviews: [],
  },
  {
    id: "biz-40",
    slug: "jain-heritage-sweets",
    name: "Jain Heritage Sweets",
    tagline: "Traditional sweets and savouries made fresh daily",
    description:
      "A trusted sweet mart in Moodabidri preparing traditional Indian sweets, hot savouries and festive gift boxes with pure ingredients and consistent taste.",
    categorySlug: "restaurants",
    subcategory: "Sweets & Namkeen",
    districtSlug: "south-canara",
    locationSlug: "moodabidri",
    address: "Jain Temple Road, Moodabidri, Dakshina Kannada - 574227",
    phone: "+91 8258 235 110",
    whatsapp: "+91 98808 35110",
    email: "orders@jainsweets.in",
    website: "",
    mapEmbedUrl: "https://www.google.com/maps?q=Moodabidri%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Traditional%20Indian%20sweet%20shop%20with%20glass%20counters%20of%20colourful%20sweets%20and%20savouries%20under%20warm%20lighting%2C%20inviting%20food%20retail%20photography&width=1200&height=800&seq=cbc-biz-jain-sweets-cover-01&orientation=landscape",
    gallery: [],
    rating: 4.4,
    reviewCount: 128,
    verified: true,
    sponsored: false,
    featured: false,
    plan: "Free",
    openNow: true,
    yearsInBusiness: 20,
    hours: [
      { day: "Monday", open: "08:30", close: "21:00", closed: false },
      { day: "Tuesday", open: "08:30", close: "21:00", closed: false },
      { day: "Wednesday", open: "08:30", close: "21:00", closed: false },
      { day: "Thursday", open: "08:30", close: "21:00", closed: false },
      { day: "Friday", open: "08:30", close: "21:30", closed: false },
      { day: "Saturday", open: "08:30", close: "21:30", closed: false },
      { day: "Sunday", open: "08:30", close: "21:00", closed: false },
    ],
    services: ["Indian Sweets", "Hot Savouries", "Gift Boxes", "Bulk Orders"],
    tags: ["Fresh Daily", "Pure Ingredients", "Festive Hampers", "Takeaway"],
    reviews: [],
  },
  {
    id: "biz-41",
    slug: "moodabidri-silk-center",
    name: "Moodabidri Silk Center",
    tagline: "Silk sarees and festive wear for the whole family",
    description:
      "A family-owned saree and textile store in Moodabidri offering Karnataka silk sarees, festive wear, readymade garments and matching accessories at fair prices.",
    categorySlug: "retail",
    subcategory: "Silk & Sarees",
    districtSlug: "south-canara",
    locationSlug: "moodabidri",
    address: "Main Road, Moodabidri, Dakshina Kannada - 574227",
    phone: "+91 8258 236 550",
    whatsapp: "+91 97421 36550",
    email: "shop@moodabidrisilk.in",
    website: "",
    mapEmbedUrl: "https://www.google.com/maps?q=Moodabidri%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Colourful%20silk%20sarees%20neatly%20stacked%20and%20displayed%20in%20a%20traditional%20textile%20showroom%20with%20warm%20lighting%2C%20apparel%20retail%20photography&width=1200&height=800&seq=cbc-biz-moodabidri-silk-cover-01&orientation=landscape",
    gallery: [],
    rating: 4.4,
    reviewCount: 112,
    verified: true,
    sponsored: false,
    featured: false,
    plan: "Free",
    openNow: true,
    yearsInBusiness: 15,
    hours: [
      { day: "Monday", open: "10:00", close: "20:30", closed: false },
      { day: "Tuesday", open: "10:00", close: "20:30", closed: false },
      { day: "Wednesday", open: "10:00", close: "20:30", closed: false },
      { day: "Thursday", open: "10:00", close: "20:30", closed: false },
      { day: "Friday", open: "10:00", close: "21:00", closed: false },
      { day: "Saturday", open: "10:00", close: "21:00", closed: false },
      { day: "Sunday", open: "10:30", close: "20:00", closed: false },
    ],
    services: ["Silk Sarees", "Festive Wear", "Readymade Garments", "Accessories"],
    tags: ["Karnataka Silk", "Family Store", "Fair Prices", "Festive Wear"],
    reviews: [],
  },
  {
    id: "biz-42",
    slug: "udupi-grand-bakery",
    name: "Udupi Grand Bakery",
    tagline: "Cakes, cookies and fresh breads baked all day",
    description:
      "A beloved bakery in Udupi city baking fresh bread, cookies and customised celebration cakes daily, with a range of puffs, sandwiches and traditional snacks.",
    categorySlug: "restaurants",
    subcategory: "Cafes & Bakeries",
    districtSlug: "udupi",
    locationSlug: "udupi-city",
    address: "Court Road, Udupi, Udupi District - 576101",
    phone: "+91 820 252 7744",
    whatsapp: "+91 98456 27744",
    email: "orders@udupigrandbakery.in",
    website: "https://udupigrandbakery.in",
    mapEmbedUrl: "https://www.google.com/maps?q=Court%20Road%20Udupi%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20bakery%20counter%20filled%20with%20fresh%20breads%2C%20cakes%20and%20cookies%20under%20warm%20display%20lighting%2C%20appetizing%20food%20retail%20photography&width=1200&height=800&seq=cbc-biz-udupi-grand-bakery-cover-01&orientation=landscape",
    gallery: [],
    rating: 4.5,
    reviewCount: 214,
    verified: true,
    sponsored: true,
    featured: false,
    plan: "Business",
    openNow: true,
    yearsInBusiness: 18,
    hours: [
      { day: "Monday", open: "07:00", close: "22:00", closed: false },
      { day: "Tuesday", open: "07:00", close: "22:00", closed: false },
      { day: "Wednesday", open: "07:00", close: "22:00", closed: false },
      { day: "Thursday", open: "07:00", close: "22:00", closed: false },
      { day: "Friday", open: "07:00", close: "22:30", closed: false },
      { day: "Saturday", open: "07:00", close: "22:30", closed: false },
      { day: "Sunday", open: "07:00", close: "22:00", closed: false },
    ],
    services: ["Fresh Breads", "Custom Cakes", "Cookies & Puffs", "Takeaway"],
    tags: ["Fresh Daily", "Custom Cakes", "Takeaway", "Bakery"],
    reviews: [],
  },
  {
    id: "biz-43",
    slug: "sri-krishna-homestay-udupi",
    name: "Sri Krishna Homestay Udupi",
    tagline: "Comfortable stay steps from the Sri Krishna Temple",
    description:
      "A tidy family homestay in Udupi near the Sri Krishna Temple offering clean air-conditioned rooms, home-cooked meals and help with local temple tours.",
    categorySlug: "hotels",
    subcategory: "Homestays",
    districtSlug: "udupi",
    locationSlug: "udupi-city",
    address: "Temple Road, Udupi, Udupi District - 576101",
    phone: "+91 820 252 8890",
    whatsapp: "+91 97411 28890",
    email: "stay@srikrishnahomestay.in",
    website: "https://srikrishnahomestayudupi.in",
    mapEmbedUrl: "https://www.google.com/maps?q=Sri%20Krishna%20Temple%20Udupi%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Clean%20welcoming%20South%20Indian%20homestay%20room%20with%20warm%20wooden%20furniture%20and%20soft%20lighting%2C%20comfort%20hospitality%20interior%20photography&width=1200&height=800&seq=cbc-biz-srikrishna-homestay-cover-01&orientation=landscape",
    gallery: [],
    rating: 4.6,
    reviewCount: 158,
    verified: true,
    sponsored: false,
    featured: false,
    plan: "Business",
    openNow: true,
    yearsInBusiness: 9,
    hours: [
      { day: "Monday", open: "00:00", close: "23:59", closed: false },
      { day: "Tuesday", open: "00:00", close: "23:59", closed: false },
      { day: "Wednesday", open: "00:00", close: "23:59", closed: false },
      { day: "Thursday", open: "00:00", close: "23:59", closed: false },
      { day: "Friday", open: "00:00", close: "23:59", closed: false },
      { day: "Saturday", open: "00:00", close: "23:59", closed: false },
      { day: "Sunday", open: "00:00", close: "23:59", closed: false },
    ],
    services: ["AC Rooms", "Home-Cooked Meals", "Temple Tours", "Free Parking"],
    tags: ["Near Temple", "Homely Stay", "Home Food", "Family Rooms"],
    reviews: [],
  },
  {
    id: "biz-44",
    slug: "udupi-study-point-coaching",
    name: "Udupi Study Point Coaching",
    tagline: "Focused coaching for PU, NEET and KCET",
    description:
      "A dedicated coaching centre in Udupi city offering PU science tuition, NEET and KCET coaching with regular tests, doubt sessions and parent progress updates.",
    categorySlug: "education",
    subcategory: "Coaching Academies",
    districtSlug: "udupi",
    locationSlug: "udupi-city",
    address: "Diana Circle, Udupi, Udupi District - 576101",
    phone: "+91 820 253 4477",
    whatsapp: "+91 99860 34477",
    email: "admissions@studypointudupi.in",
    website: "https://studypointudupi.in",
    mapEmbedUrl: "https://www.google.com/maps?q=Diana%20Circle%20Udupi%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20coaching%20academy%20classroom%20with%20desks%2C%20whiteboard%20and%20large%20windows%2C%20focused%20educational%20interior%20photography&width=1200&height=800&seq=cbc-biz-udupi-studypoint-cover-01&orientation=landscape",
    gallery: [],
    rating: 4.5,
    reviewCount: 176,
    verified: true,
    sponsored: false,
    featured: false,
    plan: "Business",
    openNow: false,
    yearsInBusiness: 12,
    hours: [
      { day: "Monday", open: "07:00", close: "20:00", closed: false },
      { day: "Tuesday", open: "07:00", close: "20:00", closed: false },
      { day: "Wednesday", open: "07:00", close: "20:00", closed: false },
      { day: "Thursday", open: "07:00", close: "20:00", closed: false },
      { day: "Friday", open: "07:00", close: "20:00", closed: false },
      { day: "Saturday", open: "07:00", close: "18:00", closed: false },
      { day: "Sunday", open: "08:00", close: "13:00", closed: false },
    ],
    services: ["PU Science Tuition", "NEET Coaching", "KCET Coaching", "Test Series"],
    tags: ["Regular Tests", "Doubt Sessions", "Experienced Faculty", "Small Batches"],
    reviews: [],
  },
  {
    id: "biz-45",
    slug: "manipal-book-house",
    name: "Manipal Book House",
    tagline: "Academic and general books in the heart of Manipal",
    description:
      "A well-stocked bookstore in Manipal offering academic titles, professional reference books, competitive exam material and stationery for students and professionals.",
    categorySlug: "retail",
    subcategory: "Gifts & Stationery",
    districtSlug: "udupi",
    locationSlug: "manipal",
    address: "Tiger Circle, Manipal, Udupi District - 576104",
    phone: "+91 820 257 6622",
    whatsapp: "+91 97312 76622",
    email: "shop@manipalbookhouse.in",
    website: "https://manipalbookhouse.in",
    mapEmbedUrl: "https://www.google.com/maps?q=Tiger%20Circle%20Manipal%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Spacious%20bookstore%20interior%20with%20tall%20shelves%20of%20books%20and%20reading%20tables%20under%20bright%20lighting%2C%20academic%20retail%20photography&width=1200&height=800&seq=cbc-biz-manipal-bookhouse-cover-01&orientation=landscape",
    gallery: [],
    rating: 4.4,
    reviewCount: 143,
    verified: true,
    sponsored: false,
    featured: false,
    plan: "Free",
    openNow: true,
    yearsInBusiness: 22,
    hours: [
      { day: "Monday", open: "09:00", close: "20:30", closed: false },
      { day: "Tuesday", open: "09:00", close: "20:30", closed: false },
      { day: "Wednesday", open: "09:00", close: "20:30", closed: false },
      { day: "Thursday", open: "09:00", close: "20:30", closed: false },
      { day: "Friday", open: "09:00", close: "20:30", closed: false },
      { day: "Saturday", open: "09:00", close: "20:30", closed: false },
      { day: "Sunday", open: "10:00", close: "18:00", closed: false },
    ],
    services: ["Academic Books", "Exam Material", "Stationery", "Book Orders"],
    tags: ["Large Collection", "Student Friendly", "Stationery", "Books"],
    reviews: [],
  },
  {
    id: "biz-46",
    slug: "manipal-dental-care",
    name: "Manipal Dental Care",
    tagline: "Modern, gentle dentistry for all ages",
    description:
      "A modern dental clinic in Manipal offering routine checkups, root canals, braces, implants and cosmetic dentistry with sterilised equipment and painless treatment.",
    categorySlug: "healthcare",
    subcategory: "Dental Clinics",
    districtSlug: "udupi",
    locationSlug: "manipal",
    address: "Eshwari Complex, Manipal, Udupi District - 576104",
    phone: "+91 820 257 3311",
    whatsapp: "+91 94493 73311",
    email: "appointments@manipaldentalcare.in",
    website: "https://manipaldentalcare.in",
    mapEmbedUrl: "https://www.google.com/maps?q=Manipal%20Udupi%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20modern%20dental%20clinic%20treatment%20room%20with%20dental%20chair%20and%20clean%20white%20interior%2C%20soft%20natural%20light%2C%20healthcare%20interior%20photography&width=1200&height=800&seq=cbc-biz-manipal-dental-cover-01&orientation=landscape",
    gallery: [],
    rating: 4.6,
    reviewCount: 198,
    verified: true,
    sponsored: false,
    featured: false,
    plan: "Business",
    openNow: true,
    yearsInBusiness: 13,
    hours: [
      { day: "Monday", open: "09:30", close: "20:00", closed: false },
      { day: "Tuesday", open: "09:30", close: "20:00", closed: false },
      { day: "Wednesday", open: "09:30", close: "20:00", closed: false },
      { day: "Thursday", open: "09:30", close: "20:00", closed: false },
      { day: "Friday", open: "09:30", close: "20:00", closed: false },
      { day: "Saturday", open: "09:30", close: "18:00", closed: false },
      { day: "Sunday", open: "10:00", close: "13:00", closed: false },
    ],
    services: ["Routine Checkups", "Root Canal", "Braces & Aligners", "Implants"],
    tags: ["Painless Treatment", "Sterilised Care", "Family Clinic", "Cosmetic Dentistry"],
    reviews: [],
  },
];